




















import Vue from 'vue'
import roles from '@/services/Roles'

export default Vue.extend({
  name: 'OwnerMenu',
  data() {
    return {
      restaurantId: this.$route.params.restaurantId,
      isAdmin: false,
    }
  },
  async created() {
    this.isAdmin = await roles.isAdmin()
  },
})
